import { Contacts } from "../Components/Contacts/Contacts";

export const ContactsPage = () => {
  return (
    <div className="extraSmal:h-full contact-h medium:pt-[6rem] extraSmal:pt-[5rem]">
      <Contacts />
    </div>
  );
};